var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"IETips"},[_c('DetailsNav'),_vm._m(0),_c('div',{staticClass:"font"},[_vm._v("微软已宣布停止IE浏览器的支持，打开有风险。 建议使用其他浏览器打开~")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labNav"},[_c('img',{attrs:{"src":require("../../assets/IETips.png"),"width":"402px","alt":""}})])
}]

export { render, staticRenderFns }